/* global axios */
// CUSTOM: bocket-contact-type-filter — BKT-027
// CUSTOM: bocket-conversations-contact-type — BKT-028 (target)
import ApiClient from '../ApiClient';

class BocketContactTypeCountsAPI extends ApiClient {
  constructor() {
    super('bocket/contact_type_counts', { accountScoped: true });
  }

  get(target = 'contacts') {
    return axios.get(this.url, { params: { target } });
  }
}

export default new BocketContactTypeCountsAPI();
